import React, { useState } from "react";

import { Grid, MenuItem, Select, SelectChangeEvent } from "@mui/material";

import SuperAdminFlag from "../components/admin-tools/super-admin-flag";
import mainStyles from "../styles";

interface AdminTool {
  label: string;
  component: React.ReactElement;
}
const tools: AdminTool[] = [
  {
    label: "Update Super Admin Flag",
    component: <SuperAdminFlag />,
  },
];

const AdminTools = () => {
  const classes = mainStyles();
  const [tabValue, setTabValue] = useState<string>(tools[0].label);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const groupToSelect = tools.find(
      (tool) => tool.label === event.target.value
    );

    if (groupToSelect) {
      setTabValue(groupToSelect.label);
    }
  };

  return (
    <Grid container sx={classes.basicSpacing} spacing={1}>
      <Grid item xs={12}>
        {tools.length !== 0 && (
          <>
            <Select
              labelId="select-admin-tools-label"
              data-testid="select-admin-tools-label"
              id="select-tool"
              value={tabValue}
              onChange={handleSelectChange}
              sx={classes.selector}
            >
              {tools.map((tool) => {
                return (
                  <MenuItem value={tool.label} key={tool.label}>
                    {tool.label}
                  </MenuItem>
                );
              })}
            </Select>
          </>
        )}

        {tools.map((tab) => {
          if (tab.label === tabValue) {
            return <div key={tab.label}>{tab.component}</div>;
          }
        })}
      </Grid>
    </Grid>
  );
};

export default AdminTools;
